import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { CardEmpresaComponent } from '../../../../../shared/components/card-empresa/card-empresa.component';
import { SearchBarComponent } from '../../../../../shared/components/search-bar/search-bar.component';
import { DialogService } from 'primeng/dynamicdialog';
import { CadastroIntituicaoEnsinoComponent } from '../cadastro-intituicao-ensino/cadastro-intituicao-ensino.component';
import { Router } from '@angular/router';
import {
  PaisService,
  ProvinciaService,
  MunicipioService,
  CommunicationService,
  TipoInstituicaoEnsinoService,
  InstituicaoEnsinoService,
  EnumService,
} from '../../api/services';
import { Subscription, forkJoin } from 'rxjs';
import { ApiService } from '@core/providers/http';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { FilterItem } from '../../api/models/filterItem.model';
import { CommonModule } from '@angular/common';
import { Pagination } from '@app/shared/model';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';
import { InstituicaoEnsino } from '../../api/models';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { Button } from 'primeng/button';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  FormBuilder,
} from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { AuthStore } from '@core/service/auth-store.service';

@Component({
  selector: 'app-lista-instituicoes-ensino',
  imports: [
    CardEmpresaComponent,
    SearchBarComponent,
    ToastModule,
    CommonModule,
    PaginatorControlComponent,
    DataVoidComponent,
    SelectModule,
    DialogModule,
    Button,
    ReactiveFormsModule,
    InputTextModule,
    BackButtonComponent,
  ],
  providers: [
    DialogService,
    ApiService,
    PaisService,
    ProvinciaService,
    MunicipioService,
    CommunicationService,
    TipoInstituicaoEnsinoService,
    InstituicaoEnsinoService,
    EnumService,
    MessageService,
  ],
  templateUrl: './lista-instituicoes-ensino.component.html',
  styleUrls: ['./lista-instituicoes-ensino.component.scss'],
  standalone: true,
})
export class ListaInstituicoesEnsinoComponent implements OnInit, OnDestroy {
  dialogService = inject(DialogService);
  paisService = inject(PaisService);
  provinciaService = inject(ProvinciaService);
  municipioService = inject(MunicipioService);
  communicationService = inject(CommunicationService);
  tipoInstituicaoEnsinoService = inject(TipoInstituicaoEnsinoService);
  instituicaoEnsinoService = inject(InstituicaoEnsinoService);
  messageService = inject(MessageService);
  private auth = inject(AuthStore);
  isLoading: boolean = false;
  first: number = 0;
  rows: number = 10;
  instituicoesCount: any;
  totalRecords: number = 120;
  pagination: Pagination<any> = new Pagination<any>();
  countries: any[] = [];
  provinces: any[] = [];
  municipalities: any[] = [];
  private enumService = inject(EnumService);
  typeofEducationalInstitution: any[] = [];
  naturezaOptions: any[] = [];

  instituicoes: InstituicaoEnsino[] = []; // sua lista

  imagePreviewMap: { [id: number]: string | ArrayBuffer | null } = {}; // To store image as Base64 URL

  sortFields: any[] = [
    {
      label: 'Nome',
      value: 'nome',
    },
  ];

  estadoOptions: any[] = [
    {
      id: 1,
      designacao: 'Activo',
    },
    {
      id: 2,
      designacao: 'Desactivado',
    },
  ];

  educationalInstitution: any[] = [];
  private subscriptions = new Subscription();
  form!: FormGroup;

  filters: FilterItem[] = [
    {
      type: 'dropdown',
      controlName: 'tipoInstituicao',
      placeholder: 'Tipo de instituição',
      options: this.typeofEducationalInstitution,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
    { type: 'text', controlName: 'nif', placeholder: ' NIF' },
    { type: 'text', controlName: 'nome', placeholder: 'Nome' },
    { type: 'text', controlName: 'Sigla', placeholder: 'Sigla' },
    {
      type: 'dropdown',
      controlName: 'estado',
      placeholder: 'Estado',
      options: this.estadoOptions,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'Provincia',
      placeholder: 'Selecione a província',
      options: this.provinces,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
  ];

  constructor(
    private router: Router,
    public fb: FormBuilder,
  ) {
    this.loadCountries();
    this.loadProvinces('193');
    this.getAllInstituicoesEnsino();
  }

  ngOnInit() {
    this.loadEnums();
    this.subscriptions.add(
      this.communicationService.countryChanged$.subscribe(
        (country: string | null) => {
          if (country) {
            this.loadProvinces(country);
          }
        },
      ),
    );

    this.subscriptions.add(
      this.communicationService.provinceChanged$.subscribe(
        (province: string | null) => {
          if (province) {
            this.loadMunicipalities(province);
          }
        },
      ),
    );

    this.form = this.fb.group({
      nif: [null],
      nome: [null],
      Sigla: [null],
      tipoInstituicao: [null],
      estado: [null],
      Provincia: [null],
    });
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  loadEnums() {
    forkJoin({
      naturezaInstituicao: this.enumService.getAllNaturezaInstituicaoEnum(),
      tipoInstituicao: this.enumService.getAllTipoInstituicaoEnum(),
    }).subscribe((response: any) => {
      if (response.naturezaInstituicao?.data) {
        this.naturezaOptions = Object.entries(
          response.naturezaInstituicao.data,
        ).map(([key, value]) => ({
          id: Number(key),
          designacao: value,
        }));
      }

      if (response.tipoInstituicao?.data) {
        this.typeofEducationalInstitution = Object.entries(
          response.tipoInstituicao.data,
        ).map(([key, value]) => ({
          id: Number(key),
          designacao: value,
        }));
        this.filters[0].options = this.typeofEducationalInstitution;
      }
    });
  }

  onFormValueChange(queryParams: any) {
    this.getAllInstituicoesEnsino(queryParams);
  }

  loadCountries() {
    this.paisService.list().subscribe((countries) => {
      this.countries = countries;
    });
  }

  loadProvinces(country: string) {
    this.provinciaService.list(country).subscribe((provinces) => {
      this.provinces = provinces;
      this.communicationService.updateProvinces(provinces);
      this.filters[5].options = provinces;
      this.municipalities = []; // Reset municipalities when country changes
    });
  }

  loadMunicipalities(province: string) {
    this.municipioService.list(province).subscribe((municipalities) => {
      this.municipalities = municipalities;
      this.communicationService.updateMunicipalities(municipalities);
    });
  }

  showDialog() {
    if (this.auth.hasAny(['registar_instituições_ensino'])) {
      const ref = this.dialogService.open(CadastroIntituicaoEnsinoComponent, {
        showHeader: false,
        width: '45%',
        modal: true,
        data: {
          countries: this.countries,
          provinces: this.provinces,
          municipalities: this.municipalities,
          typeofEducationalInstitution: this.typeofEducationalInstitution,
          naturezaOptions: this.naturezaOptions,
          isEditMode: false,
        },
      });

      ref.onClose.subscribe((data) => {
        if (data instanceof FormData) {
          this.isLoading = true;

          this.instituicaoEnsinoService.store(data).subscribe({
            next: (response: any) => {
              this.isLoading = false;
              if (response.retorno?.codigo === 200) {
                this.messageService.add({
                  severity: 'success',
                  summary: 'Sucesso',
                  detail: 'Instituição de Ensino registada com sucesso!',
                  life: 3000,
                });
                this.getAllInstituicoesEnsino();
              } else {
                this.messageService.add({
                  severity: 'error',
                  summary: 'Erro',
                  detail:
                    response.retorno?.mensagem ||
                    'Erro ao criar instituição de ensino.',
                  life: 3000,
                });
              }
            },
            error: (error: any) => {
              this.isLoading = false;
              console.error('Erro ao criar instituição de ensino:', error);
              this.messageService.add({
                severity: 'error',
                summary: 'Erro',
                detail:
                  error.error?.retorno?.mensagem ||
                  'Erro ao criar instituição de ensino.',
                life: 3000,
              });
            },
          });
        }
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Permissão Inválida',
        detail: 'Não tens permissão para efetuar esta acção',
        life: 3000,
      });
    }
  }

  getAllInstituicoesEnsino(queryParams: any = {}): void {
    this.isLoading = true;

    const params = {
      ...queryParams,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 10,
      OrderBy: queryParams?.OrderBy || 'id desc',
    };

    this.instituicaoEnsinoService.list(params).subscribe({
      next: (response: any) => {
        this.instituicoes = response.data;
        this.pagination = new Pagination<any>().deserialize(response);
        this.instituicoesCount = this.pagination?.totalRecords;
        this.isLoading = false;

        // Inicia o carregamento das imagens sem travar o fluxo principal
        this.instituicoes.forEach((inst) => {
          this.loadImagemInstituicao(inst.id);
        });
      },
      error: (error) => {
        console.error('Erro ao carregar instituições de ensino:', error);
        this.isLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao buscar instituições de ensino.',
          life: 3000,
        });
      },
    });
  }

  loadImagemInstituicao(id: number): void {
    this.instituicaoEnsinoService.getFotoInstituicaoById(id).subscribe({
      next: (response: Blob) => {
        const reader = new FileReader();
        reader.onload = () => {
          this.imagePreviewMap[id] = reader.result as string;
        };
        reader.onerror = () => {
          this.imagePreviewMap[id] = null;
        };
        reader.readAsDataURL(response);
      },
      error: (err) => {
        console.error(`Erro ao carregar imagem da instituição ${id}:`, err);
        this.imagePreviewMap[id] = null;
      },
    });
  }

  showFilter: boolean = false;

  showFilterModal() {
    this.showFilter = true;
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.getAllInstituicoesEnsino();
  }

  handleFormValueChange(event: any) {
    const filters = Object.fromEntries(
      Object.entries(event).filter(
        ([_, value]) => value !== null && value !== undefined && value !== '',
      ),
    );
    console.log('Filtered values:', filters);
    this.getAllInstituicoesEnsino(filters);
    this.showFilter = false;
  }

  trackById(index: number, item: any) {
    return item.id ?? index;
  }

  routerLink(item: any) {
    this.router.navigate([
      '/gestao-bolseiros/instituicao-ensino/detalhe-instituicao/',
      item.id,
    ]);
  }
}
